import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const STAT_KEYS = ["s1", "s2", "s3"];
const TABLE_ROWS = ["r1", "r2", "r3", "r4", "r5", "r6", "r7", "r8"];

const ClientInfoPageSkeleton = () => (
	<Box sx={{ maxWidth: 1200, mx: "auto", pt: 2, width: "100%" }}>
		<Skeleton variant="text" width={120} height={20} sx={{ mb: 2 }} />
		<Stack direction="row" spacing={2} sx={{ mb: 3 }}>
			<Skeleton
				variant="rectangular"
				width={96}
				height={128}
				sx={{ borderRadius: 1 }}
			/>
			<Box sx={{ flex: 1 }}>
				<Skeleton variant="text" width={200} height={32} sx={{ mb: 1 }} />
				<Stack direction="row" spacing={2}>
					{STAT_KEYS.map((key) => (
						<Paper key={key} sx={{ p: 1.5, flex: 1 }}>
							<Skeleton variant="text" width={80} height={16} />
							<Skeleton variant="text" width={60} height={28} />
						</Paper>
					))}
				</Stack>
			</Box>
		</Stack>
		<Stack
			direction="row"
			sx={{
				justifyContent: "space-between",
				alignItems: "center",
				mb: 2,
			}}
		>
			<Skeleton variant="text" width={180} height={24} />
			<Skeleton
				variant="rectangular"
				width={140}
				height={40}
				sx={{ borderRadius: 1 }}
			/>
		</Stack>
		<Paper sx={{ p: 2 }}>
			<Stack spacing={1}>
				{TABLE_ROWS.map((key) => (
					<Stack key={key} direction="row" spacing={2} sx={{ py: 1 }}>
						<Skeleton variant="text" width={40} height={20} />
						<Skeleton variant="text" width={100} height={20} sx={{ flex: 1 }} />
						<Skeleton variant="text" width={80} height={20} />
						<Skeleton variant="text" width={60} height={20} />
						<Skeleton variant="text" width={60} height={20} />
					</Stack>
				))}
			</Stack>
		</Paper>
	</Box>
);

export default ClientInfoPageSkeleton;
